<template> 
  <!-- <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/bg-award-gjs.jpg) no-repeat;background-size:100%;">  -->
  <div style="height: 100vh;background:url(https://ccago.oss-cn-hangzhou.aliyuncs.com/bg-award-jys.jpg) no-repeat;background-size:100%;"> 
    <!-- <div class="machine-head" style="font-size:60px;letter-spacing:10px;height:120px;line-height:120px;
  text-shadow: 2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000;position:relative" :style="{'color':'#fff','background':'#ea0000'}">
      <img style="width:100px;margin-right:10px;  ; position: absolute;" src="https://wa.ccachina.net/img/logo.58b57af4.png" /> 
      <div style=" text-align:center">{{ row.title }}
        实时成绩22
      </div>
        <img style="width:100px;position: absolute; float:right;top:20px;right:20px" src="https://wa.ccachina.net/img/logo.58b57af4.png" /> 
      <div>{{ row.saiqu_name }}</div>
    </div> -->
    <div style="background: rgba(255,255,255,0.74);
border: 10px solid rgba(164,208,255,0.43);
border-radius: 20px;
    margin-left: 20px;
    margin-right: 20px;
    height: 100px;
    letter-spacing:0.2em; 
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;
    line-height: 100px;
    margin-bottom: 10px;
    text-align: center;
    color: #000;
    font-size: 48px;
    padding: 0px 20px;
    font-weight: bold;
    ">{{start.subject_name}}</div>
    <div style=" 
    text-align:center;
    height:auto;line-height:140px; margin:10px;color:#ca9a9a;font-size:80px;padding:0;
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;
     font-weight:bold
    "> 
    {{start.mingcheng}}</div>

    <!-- <div class="machine-box" :style="'height:' + (clientHeight -104 - 20) + 'px;'"> -->
    <div class="machine-box"  style="margin:10px;height:100%" :style="{'color':row.show_font_color}">
      <div class="machine-content">
        <!-- <div class="machine-subject">{{start.subject_name}}</div> -->
        <!-- <div class="machine-army">{{start.mingcheng}}</div> -->
 
        <table class="machine-table" :style="{'color':row.show_font_color_2}">
          <thead>
          <tr style="color:#ca9a9a;
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;">
            <th>排名</th> 
            <th>总分</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style="padding:20px;"><div style="background-image: linear-gradient(180deg, #E04063 0%, #B71C3E 48%, #E04063 100%); border-radius:10px;color:#ffffffcc;">{{ start.rank }}</div></td>
             <td style="padding:20px;"><div style="background-image: linear-gradient(180deg, #09BA83 0%, #007650 48%, #09BA83 100%); border-radius:10px;color:#ffffffcc;">
              {{ start.score_total }}
              </div>
            </td>
          </tr>
          </tbody>

        </table>
      </div>

    </div>


  </div>
</template>
<style scoped>
  
body {
  overflow-y: hidden;
}

.machine-table {
  /* margin-top: 80px; */
  width: 100%;
  /* color: #E3E59D; */
}

.machine-box {
  /* background: #0782B8; */
  text-align: center;
  /* color: #fff; */
  display: flex;
  justify-content: center; /*使子项目水平居中*/
  /*align-items: center; !*使子项目垂直居中*!*/
}

.machine-content {
  margin: 30px 0 0;
  width: 90%;
}

.machine-content .machine-subject {
  font-size: 46px;
}

.machine-content .machine-army {
  font-size: 46px;
  margin-top: 20px;
  font-weight: 500;
}

.machine-box .machine-subject, .machine-box .machine-army {
  /*display: inline-block;*/
}

table {
  /* color: #E3E59D; */
  table-layout: fixed; 
  width: 100%;
}

table thead th {
  font-size: 80px;
  letter-spacing: 0.2em;
  font-weight: bold;
}

table tbody {
  font-size: 128px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
}

table th, table td {
  height: 50px; 
}

table thead th:first-child, table tbody td:first-child {
  /* width: 80%; */
  text-align: center;
}

table thead th:last-child, table tbody td:last-child {
  /*width: 80%;*/
  text-align: center;
}


table thead th, table tbody td {
  /* min-width: 25%;  */
}


.pointer {
  cursor: pointer;
}

.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 20px;
  text-align: left;
  font-size: 36px;
  /* color: #fff; */
  font-weight: bold;
}


.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


</style>
<script>

export default {
  name: 'ScoreStartMachineRank',
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    start: {
      type: Object,
      default: () => {}
    },
    list:{
      type: Array,
      default: []
    }
  },
  components: {
  },
  data() {
    return {
      loading: false,
      thisIndex:0,
      saveLoading: false,
      drawerVisible: false,
      scoreVisible: false,
      rankVisible: false,
      dataVisible: false, // 修改数据
      currentFilter: false,
      currentCpIndex: 0,
      // tableHeight:document.documentElement.clientHeight-180,
      // tableHeight:300,

      scoreList: [],
      formData: {
        id: 0
      },

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      clientHeight: 0
    }

  },
  watch:{
    list(){ 
      let that = this
      console.log('watch list')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    },
    start(){ 
      let that = this
      console.log('watch start')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    }
  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '队伍信息'
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  computed: {},
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// ScoreAwardOne.vue?78ebf57b